module.exports = __webpack_public_path__ + "img/logo.26ba61eb.png";